import { Input } from "@heroui/react";
import { CloseIcon, SearchIcon } from '../../../assets/icons';

const SearchBar = ({ variant, placeholder, startContent, endContent, className, label, radius, value, onValueChange, onKeyDown, onClear, disabled }) => {
    return (
        <Input
            variant={variant}
            label={label}
            classNames={{
                inputWrapper: "!rounded !shadow-none !border-1 !h-6",
                input: "placeholder:text-[14px] placeholder:font-[400]"
            }}
            className={className}
            placeholder={placeholder}
            startContent={startContent ? startContent : <SearchIcon color="#000000" />}
            endContent={endContent ? endContent : value?.length > 0 && <button type="button" aria-label="Clear search" onClick={onClear}><CloseIcon /></button>}
            radius={radius}
            value={value}
            onValueChange={onValueChange}
            onKeyDown={onKeyDown}
            isDisabled={disabled}
        />
    )
}

export default SearchBar;
